import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Skeleton = React.forwardRef((props, ref) => {
  const {
    animation = true,
    asElement: Component = 'span',
    className,
    height,
    style,
    variant = 'block',
    width
  } = props

  return (
    <Component
      ref={ref}
      className={classNames(
        'skeleton',
        variant === 'circle' && 'skeleton-circle',
        variant === 'block' && 'skeleton-block',
        animation && 'animate-pulse',
        className
      )}
      style={{
        width,
        height,
        ...style
      }}
    />
  )
})

Skeleton.displayName = 'Skeleton'

Skeleton.propTypes = {
  asElement: PropTypes.string,
  variant: PropTypes.oneOfType([
    PropTypes.oneOf(['circle', 'block']),
    PropTypes.string
  ]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default Skeleton
